<template>
    <section>
        <div class="modal-fullscreen-sm-down" id="occurrenceHistoryModal" v-if="openModal">
						<div class="modal">
							<div class="modal-content">

								<div class="formHeader d-flex justify-content-between align-items-center" style="text-align: start">
									<div class="header-content d-flex align-items-center">
										<img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
											<span v-if="!toggleDetails" style="vertical-align: middle; font-weight: 600">Histórico de Chamados</span>
											<span v-else style="vertical-align: middle; font-weight: 600">Detalhes do Chamado: {{occurrenceDetails.protocol}}</span>
									</div>
									<div id="closeButtonDiv">
										<button id="closeButton" v-on:click="closeHistory();closeDetails()"><i class="fas fa-window-close fa-lg"></i></button>
									</div>
								</div>

									<div class="container-fluid" id="formBody">
											<div v-if="!toggleDetails" id="table-container" class="grid-column">
											<div id="filterDiv" style="text-align: end; margin: 5px">
													<label for="statusSelect"><strong>Exibição por Status</strong></label>
													<select name="statusSelect" v-model="statusSelect" id="statusSelect">
															<option default value="*">Todos</option>
															<option value="aberto">Aberto</option>
															<option value="andamento">Em Andamento</option>
															<option value="pendente fornecedor">Pendente Fornecedor</option>
															<option value="validação cliente">Validação Cliente</option>
															<option value="finalizado">Finalizado</option>
													</select>
											</div>
											<div class="d-flex justify-content-start">
													<button class="buttonCSV" id="exportCSV" @click="exportCSV()"><i class="fas fa-w fa-table" aria-hidden="true"></i> Exportar CSV</button>
													<button class="buttonPDF" id="exportPDF" @click="exportPDF()"><i class="fas fa-w fa-file-pdf" aria-hidden="true"></i> Exportar PDF</button>
											</div>
													<div>
															<div style="text-align: end; margin: 5px">
																	<input type="text" name="searchBox" v-model="searchQuery" class="form-control" placeholder="Digite para buscar um chamado..." />
															</div>
													</div>
													<div style="overflow: auto; height: 50vh">
															<table class="tables mb-6 sticky-header" id="occurrencesTable" style="width: 100%; border-collapse: separate">
																	<thead style="position: static;">
																			<tr class="noSelect">
																					<th @click="currentSort = 'protocol';
																							{switchSortDir = !switchSortDir}"
																							class="text-center">
																							Protocolo
																							<i v-if="currentSortDir == 'asc' && currentSort == 'protocol'" class="fas fa-xs fa-arrow-up"></i>
																							<i v-if="currentSortDir == 'desc' && currentSort == 'protocol'" class="fas fa-xs fa-arrow-down"></i>
																					</th>
																					<th @click="currentSort = 'created_at';
																							{switchSortDir = !switchSortDir}"
																							class="text-center">
																							Data e Hora de Abertura
																							<i v-if="currentSortDir == 'asc' && currentSort == 'created_at'" class="fas fa-xs fa-arrow-up"></i>
																							<i v-if="currentSortDir == 'desc'&& currentSort == 'created_at'" class="fas fa-xs fa-arrow-down"></i>
																					</th>
																					<th @click="currentSort = 'sla';
																							{switchSortDir = !switchSortDir}"
																							class="text-center">
																							SLA
																							<i v-if="currentSortDir == 'asc' && currentSort == 'sla'" class="fas fa-xs fa-arrow-up"></i>
																							<i v-if="currentSortDir == 'desc'&& currentSort == 'sla'" class="fas fa-xs fa-arrow-down"></i>
																					</th>
																					<th @click="currentSort = 'occurrence_closure';
																							{switchSortDir = !switchSortDir}"
																							class="text-center">
																							Data de Encerramento
																							<i v-if="currentSortDir == 'asc' && currentSort == 'occurrence_closure'" class="fas fa-xs fa-arrow-up"></i>
																							<i v-if="currentSortDir == 'desc'&& currentSort == 'occurrence_closure'" class="fas fa-xs fa-arrow-down"></i>
																					</th>
																					<th @click="currentSort = 'customer_name';
																							{switchSortDir = !switchSortDir}"
																							class="text-center">
																							Cliente
																							<i v-if="currentSortDir == 'asc' && currentSort == 'customer_name'" class="fas fa-xs fa-arrow-up"></i>
																							<i v-if="currentSortDir == 'desc' && currentSort == 'customer_name'" class="fas fa-xs fa-arrow-down"></i>
																					</th>
																					<th @click="currentSort = 'type_name';
																							{switchSortDir = !switchSortDir}"
																							class="text-center">
																							Tipo de Chamado
																							<i v-if="currentSortDir == 'asc' && currentSort == 'type_name'" class="fas fa-xs fa-arrow-up"></i>
																							<i v-if="currentSortDir == 'desc' && currentSort == 'type_name'" class="fas fa-xs fa-arrow-down"></i>
																					</th>
																					<th @click="currentSort = 'technician';
																							{switchSortDir = !switchSortDir}"
																							class="text-center">
																							Responsável
																							<i v-if="currentSortDir == 'asc' && currentSort == 'technician'" class="fas fa-xs fa-arrow-up"></i>
																							<i v-if="currentSortDir == 'desc' && currentSort == 'technician'" class="fas fa-xs fa-arrow-down"></i>
																					</th>
																					<th @click="currentSort = 'status_name';
																							{switchSortDir = !switchSortDir}"
																							class="text-center">
																							Status
																							<i v-if="currentSortDir == 'asc' && currentSort == 'status_name'" class="fas fa-xs fa-arrow-up"></i>
																							<i v-if="currentSortDir == 'desc' && currentSort == 'status_name'" class="fas fa-xs fa-arrow-down"></i>
																					</th>
																					<th class="text-center">Visualizar</th>
																			</tr>
																	</thead>
																	<div v-if="loadingTable" id="loading">
																			<p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Carregando chamados...</strong></p>
																	</div>

																	<tbody v-if="chamadosUser != '' && !loadingTable">
																			<tr v-for="el in paginatedResults" :key='el.protocol'>
																					<td id="protocol" class="text-center">{{el.protocol}}</td>
																					<td id="startDate" class="text-center">{{formatDate(el.created_at)}}</td>
																					<td id="sla" class="text-center">{{formatDate(slaTime(el.created_at, el.sla))}}</td>
																					<td id="closure" class="text-center">{{(el.occurrence_closure ? formatDate(el.occurrence_closure) : '-')}}</td>
																					<td class="text-center">{{el.customer_name}}</td>
																					<td class="text-center"> {{el.type_name}} </td>
																					<td class="text-center"> {{getOccurrenceTech(el)}} </td>
																					<td class="text-center"> {{el.status_name}} </td>
																					<td class="text-center"> <button class="btn btn-primary" v-on:click="showDetails(el)" ><i class="fas fa-eye"></i></button> </td>
																			</tr>
																	</tbody>
																	<tbody v-if="chamadosUser == '' && loadingTable == false">
																		<tr>
																				<td colspan="8" style="font-weight: 600; text-align: center">Não há chamados para exibir!</td>
																		</tr>
																</tbody>
															</table>
													</div>
													<div v-if="objLength > 1" id="bottomDiv">
															<p>Total de <strong>{{objLength}}</strong> chamados. Página <strong>{{currentPage}}</strong> de <strong>{{Math.ceil(objLength / pageSize)}}</strong></p>
															<button class="button-page btn btn-light" @click="prevPage">Anterior</button>
															<button class="button-page btn btn-light" @click="nextPage">Próximo</button>
													</div>
										</div>
											<div v-else class="container-fluid" id="details">
													<div class="row">
															<div class="column" style="border-bottom: 2px solid lightgray;">
																	<!-- <h3 id="tituloDetalhes">Detalhes do Chamado: {{occurrenceDetails.protocol}}</h3> -->
															</div>
													</div>
													<div class="row" style="height: 50vh; margin-top: 10px; margin-bottom: 10px">
															<div class="column" style="border-right: 1px solid lightgray; overflow-y: auto">
																	<div class="input-group-prepend" id="customerInput">
																			<span class="input-group-text">
																					Cliente
																			</span>
																			<input
																					type="text"
																					class="form-control"
																					name="customer"
																					id="customer"
																					v-model="occurrenceDetails.customer_name"
																					disabled=true
																			/>
																	</div>
																	<div class="input-group-prepend" id="departmentInput">
																			<span class="input-group-text">
																					Departamento
																			</span>
																			<input
																					type="text"
																					class="form-control"
																					name="department"
																					id="department"
																					v-model="occurrenceDetails.department_name"
																					disabled=true
																			/>
																	</div>
																	<div class="input-group-prepend" id="typeInput">
																			<span class="input-group-text">
																					Tipo de Chamado
																			</span>
																			<input
																					type="text"
																					class="form-control"
																					name="type"
																					id="type"
																					v-model="occurrenceDetails.type_name"
																					disabled=true
																			/>
																	</div>
																	<div class="input-group-prepend" id="statusInput">
																			<span class="input-group-text">
																					Status
																			</span>
																			<input
																					type="text"
																					class="form-control"
																					name="status"
																					id="status"
																					v-model="occurrenceDetails.status_name"
																					disabled=true
																			/>
																	</div>
																	<div class="input-group-prepend" id="closureInput">
																			<span class="input-group-text">
																					Data do Fechamento
																			</span>
																			<input v-if="occurrenceDetails.occurrence_closure"
																					type="text"
																					class="form-control"
																					name="closure"
																					id="closure"
																					v-model="occurrenceDetails.occurrence_closure"
																					disabled=true
																			/>
																			<input v-else
																					type="text"
																					class="form-control"
																					name="closure"
																					id="closure"
																					value="Chamado não finalizado"
																					disabled=true
																			/>
																	</div>
																	<div class="input-group-prepend" id="technicianSelect">
																			<span class="input-group-text">
																					Técnicos Responsáveis
																			</span>
																			<select
																					class="form-control"
																					name="technician"
																					id="technician"
																					multiple="true"
																					disabled="true"
																					style="height: 4em; max-height: 4em; overflow-y: auto; resize: none"
																			><option :key="x.id" v-for="x in technicianList" v-bind:value="x.id">{{x.name}}</option>
																			</select>
																	</div>
															</div>
															<div class="column" style="border-left: 1px solid lightgray;">
																	<div class="input-group-prepend" id="descriptionArea">
																			<span class="input-group-text">
																					Descrição
																			</span>
																			<textarea
																					class="form-control"
																					name="description"
																					id="description"
																					v-model="occurrenceDetails.description"
																					style="height: 5em; max-height: 5em; overflow-y: auto; resize: none"
																					disabled=true
																					resize="none"
																			>
																			</textarea>
																	</div>
																	<div class="input-group-prepend" id="technicalNote">
																			<span class="input-group-text">
																					Nota Técnica
																			</span>
																			<textarea v-if="occurrenceDetails.technicalNote"
																					class="form-control"
																					name="technicalNote"
																					id="technicalNote"
																					v-model="occurrenceDetails.technicalNote"
																					style="height: 5em; max-height: 5em; overflow-y: auto; resize: none"
																					disabled=true
																			>
																			</textarea>
																			<textarea v-else
																					class="form-control"
																					name="technicalNote"
																					id="technicalNote"
																					style="height: 5em; max-height: 5em; overflow-y: auto; resize: none"
																					disabled=true
																			>Sem Nota Técnica para exibir
																			</textarea>
																	</div>
																	<div style="display: flex">
																			<div class="input-group-prepend justify-content-center" style="flex: 1" id="openComment">
																					<button class="btn btn-primary" id="openComments" style="z-index: 0; width: 100%; line-height: 2; background-color: rgb(28,134,154)" @click.prevent="openComments()"><i class="fas fa-2x fa-comment"></i><br>Comentários</button>
																			</div>
																	</div>

																	<comments-modal2 :noInsert="true" :chamadoId="occurrenceDetails.id" v-if="showComments"  v-on:closeComments="showComments = !showComments"></comments-modal2>
															</div>
													</div>
															<div class="row" style="height: 3em; margin-top: .5em">
																	<div class="column">
																			<button style="width: 12em; align-self: center" class="btn btn-danger" v-on:click="closeDetails()"><i class="fas fa-window-close fa-lg"></i> Fechar Detalhes</button>
																	</div>
															</div>
											</div>
									</div>
							</div>
					</div>
			</div>
    </section>
</template>

<script>
    import commentsModal from './commentsModal2';

    export default {
        props: ['toggleHistory', 'techList', 'dadosChamado'],

        components: {
            commentsModal
				},

        data(){
            return {
                openModal: false,
                obj: [],
                protocol: '',
                statusSelect: '*',
                currentSort:'created_at',
                currentSortDir:'desc',
                switchSortDir: false,
                pageSize:10,
                currentPage:1,
                objLength: '',
                toggleDetails: false,
                occurrenceDetails: [],
                technicianList: [],
                searchQuery: '',
                chamadosUser: [],
                showComments: false,
                begin: '',
                end: '',
                loadingTable: false,
                tableMessage: true,
								list: []
            }
        },

        computed: {
            compareProtocol() {
                return this.protocol;
            },
            paginatedResults:function() {
                return this.chamadosUser.sort((a,b) => {
                    let modifier;
                    if (!this.switchSortDir) { //DESC
                        this.currentSortDir = 'desc'
                        modifier = -1
                    } else {
                        this.currentSortDir = 'asc'
                        modifier = 1
                    }
                    if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier
                    if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier
                    return 0;
                })
                .filter((row, index) => {
                    let start = (this.currentPage-1)*this.pageSize
                    let end = this.currentPage*this.pageSize
                    if(index >= start && index < end) return true
                }, this.objLength = this.chamadosUser.length )
            },
        },


        methods: {
            getFilteredObject: function (){
                return this.obj.filter(row => {
                    const status = row.status_name.toLowerCase();
                if (this.statusSelect == '*'){
                    return (status.includes('aberto') || status.includes('andamento') || status.includes('finalizado') || status.includes('pendente fornecedor') || status.includes('validação cliente'));
                } else return status.includes(this.statusSelect.toLowerCase());
                });
            },

            closeHistory(){
                this.openModal = !this.openModal;
                this.$emit('closeHistory');
            },

            nextPage:function() {
                if((this.currentPage*this.pageSize) < this.chamadosUser.length) this.currentPage++;
            },

            prevPage:function() {
                if(this.currentPage > 1) this.currentPage--;
            },

            formatDate(stringDate){
                let p = stringDate.split(/\D/g);
                let date = [p[2],p[1],p[0] ].join("/");
                let time = stringDate.split(/\s(.+)/g)[1];
                return `${date} ${time}`;
            },

            showDetails:function(data) {
                this.toggleDetails = true;
                this.occurrenceDetails = data;
            },

            closeDetails:function() {
                this.toggleDetails = false;
                this.technicianList = [];
            },

            openComments(){
                this.showComments = !this.showComments;
            },

            slaTime: function(created, sla) {
        const businessStart = 8; 
        const businessEnd = 18; 

        const createdDate = new Date(created);
        const slaSplit = sla.split(':');
        let slaInSeconds = (+slaSplit[0]) * 60 * 60 + (+slaSplit[1]) * 60 + (+slaSplit[2]);

        let currentDate = new Date(createdDate);
        let totalSeconds = 0;

        while (slaInSeconds > 0) {
            const currentHour = currentDate.getHours();

            if (currentHour >= businessStart && currentHour < businessEnd) {
                totalSeconds++;
                slaInSeconds--;
            }

            currentDate.setSeconds(currentDate.getSeconds() + 1);

            if (currentHour === businessEnd && slaInSeconds > 0) {
                currentDate.setDate(currentDate.getDate() + 1); 
                currentDate.setHours(businessStart, 0, 0); 
            }
            if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
                currentDate.setDate(currentDate.getDate() + 1);
                currentDate.setHours(businessStart, 0, 0);
            }
        }
        return moment(currentDate).format('YYYY-MM-DD HH:mm:ss');
    },

            timeUp: function(endTime, protocol){
                let fullDateRaw = new Date()
                let nowMs = fullDateRaw.getTime()

                let end = new Date(endTime)
                let endMs = end.getTime()
                return endMs < nowMs;
            },

            getOccurrenceTech: function(occurrence){
                let techArray = []
                let techString = ''

                if(occurrence.technician_id){
                    occurrence.technician_id.forEach(item => {
                        let tech = this.techList.find(el => el.value == item)
                        if (tech){
                            techArray.push(tech.text)
                        }
                    })
                    if (techArray.length > 0) {
                        techString = techArray.join('/')
                    }
                }
                return techString
            },

            download_csv: function(csv, filename) {
                let csvFile;
                let downloadLink;


                csvFile = new Blob(["\uFEFF"+csv], {
                    type: 'text/csv; charset=utf-18'
                });

                downloadLink = document.createElement("a");

                downloadLink.download = filename;

                downloadLink.href = window.URL.createObjectURL(csvFile);

                downloadLink.style.display = "none";

                document.body.appendChild(downloadLink);

                downloadLink.click();
            },

            export_table_to_csv: function() {
                let result = []
                var occurrences = this.chamadosUser
                let closure = ''
                let now = new Date().toLocaleString()
                let dateString = now.replace(/\D/g,'_')

                let header = 'Protocolo,Data de Abertura,SLA,Cliente,Tipo,Departamento,Técnicos Responsáveis,Status do Chamado,Data de Encerramento,Tempo de Atendimento'
                result.push(header)

                occurrences.forEach(obj => {
                    let techArray = []
                    let techString = ''
                    let attendanceTimeMs = ''
                    let attendanceTime = ''

                    if(obj.technician_id){
                        obj.technician_id.forEach(item => {
                            let tech = this.techList.find(el => el.value == item)
                            if (tech){
                                techArray.push(tech.text)
                            }
                        })
                    }
                    if (techArray.length > 0) {
                        techString = techArray.join('/')
                    }

                    if(obj.occurrence_closure == null){
                        closure = '-'
                        attendanceTime = '-'
                    } else {
                        closure = this.formatDate(obj.occurrence_closure)
                        let closureMs = new Date(obj.occurrence_closure).getTime()
                        let createdMs = new Date(obj.created_at).getTime()

                        if(closureMs > createdMs){
                            attendanceTimeMs = closureMs - createdMs

                            const seconds = Math.floor((attendanceTimeMs / 1000) % 60)
                            const minutes = Math.floor((attendanceTimeMs / 1000 / 60) % 60)
                            const hours = Math.floor((attendanceTimeMs / 1000 / 3600) % 24)

                            attendanceTime = [
                                (hours.toString().length < 2) ? '0'+hours.toString() : hours.toString(),
                                (minutes.toString().length < 2) ? '0'+minutes.toString() : minutes.toString(),
                                (seconds.toString().length < 2) ? '0'+seconds.toString() : seconds.toString(),
                            ].join(':')
                        } else {
                            attendanceTime = '-'
                        }
                    }

                    let row = obj.protocol + ',' +
                    this.formatDate(obj.created_at) + ',' +
                    this.formatDate(this.slaTime(obj.created_at, obj.sla)) + ',' +
                    obj.customer_name + ',' +
                    obj.type_name + ',' +
                    obj.department_name + ',' +
                    techString + ',' +
                    obj.status_name + ',' +
                    closure + ',' +
                    attendanceTime

                    result.push(row)
                })

                this.download_csv(result.join("\n"), `Chamados_${dateString}.csv`);
            },

            exportCSV: function(){
                if (this.chamadosUser){
                    var html = document.querySelector("table").outerHTML;
                    this.export_table_to_csv();
                }  else {
                    Swal.fire({
                        type: "error",
                        title: "Erro!",
                        text: "Você não possui chamados para gerar um CSV!"
                    })
                }
            },

            async exportPDF() {
                let header = []
                let rows = []

                header.push({text:'Protocolo', style:'header'})
                header.push({text:'Data de Abertura', style:'header'})
                header.push({text:'SLA', style:'header'})
                header.push({text:'Cliente', style:'header'})
                header.push({text:'Tipo', style:'header'})
                header.push({text:'Departamento', style:'header'})
                header.push({text:'Status', style:'header'})
                rows.push(header)

                let now = new Date().toLocaleString()

                let occurrence = []
                if (this.chamadosUser){
                    let occurrenceObj = this.chamadosUser
                        if (pdfMake.vfs == undefined){
                            pdfMake.vfs = pdfFonts.pdfMake.vfs;
                        }

                        occurrenceObj.forEach(obj => {
                            occurrence = []
                            occurrence.push(obj.protocol)
                            occurrence.push(this.formatDate(obj.created_at))
                            occurrence.push(this.formatDate(this.slaTime(obj.created_at, obj.sla)))
                            occurrence.push(obj.customer_name)
                            occurrence.push(obj.type_name)
                            occurrence.push(obj.department_name)
                            occurrence.push(obj.status_name)

                            rows.push(occurrence)
                        })

                    var dd = {
                        pageOrientation: 'landscape',
                    	content: [
                            {image: 'data:image/png;base64,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',
                                width: 100,
                                height: 100,
                                absolutePosition: {x: 50, y: 20}
                    	    },
                    		{text: 'Chamados', style: 'mainTitle'},
                            {text: 'Data: ' + now, style: 'dateInfo'},
                    	    {
                    		    style: 'bodyTable',
                    		    table: {
                                    headerRows: 1,
                                    widths: ['*', 70, 70,  70,'*',70,'*',70],
                    		        body: rows
                    		    }
                    	    },
                    	    {
                                layout: 'noBorders',
                    		    style: 'footer',
                    		    table: {
                                    widths: ['*'],
                    		        body: [
                                        [{text: 'TELEADVANCE ADM DE SERV TELECOM DO BRASIL LTDA ', bold: true}],
                    		            [{text: 'R. Pais Leme, 215 - Pinheiros, São Paulo - SP, 05424-150', fontSize: 14}],
                    		            [{text: '(11) 3540-0000', fontSize: 14}],
                    		        ]
                    		    }
                    	    },

                    	],
                    	styles: {
                    		mainTitle: {
                                fontSize: 24,
                    			bold: true,
                    			margin: [0, 0, 0, 30],
                    			alignment: 'center'
                    		},
                    		subTitle: {
                    			fontSize: 14,
                    			bold: true,
                    			margin: [0, 0, 0, 15],
                    			alignment: 'center'
                    		},
                    		dateInfo: {
                                margin: [0, 0, 0, 10],
                    		    alignment: 'right',
                                bold: true
                    		},
                    		header: {
                                fontSize: 12,
                    		    bold: true,
                    			margin: [0, 0, 5, 5],
                    			lineHeight: 1,
                                alignment: 'center'
                    		},
                    		bodyTable: {
                                alignment: 'center',
                                fontSize: 10,
                    		    bold: false,
                    			margin: [0, 0, 0, 0],
                                dontBreakRows: true
                    		},
                    		bottomLine: {
                    		    fontSize: 12,
                    		    lineHeight: 3,
                    		    margin: [0, 5]
                    		},
                    		footer: {
                                alignment: 'center',
                    		    margin: [0, 15],
                    		    fontSize: 16

                    		}
                    	},
                    	defaultStyle: {
                            // alignment: 'justify'
                    	}

                    }
                    pdfMake.createPdf(dd).open()
                } else {
                    Swal.fire({
                        type: "error",
                        title: "Erro!",
                        text: "Você não possui chamados para gerar um PDF!"
                    })
                }
            },
        },

        created(){

        },

        watch: {
            toggleHistory: function() {
                this.openModal = this.toggleHistory;
                this.tableMessage = true;
                if (!this.toggleHistory){
                    this.chamadosUser = [];
                    this.obj = [];
                    this.begin = '';
                    this.end = '';
                }

								this.loadingTable = true;
            		axios.get(`/getChamadosID?begin=${this.dadosChamado}`).then(data => {
										this.loadingTable = false,
										this.obj = data.data,
										this.chamadosUser = data.data,
										this.objLength =  this.chamadosUser.length
            		});
            },

            occurrenceDetails: function() {
                axios.get("/operator/userList").then(({data}) => {
                    this.occurrenceDetails.technician_id.forEach(item => {
                        data.forEach(element => {
                            if (item == element.id){
                                this.technicianList.push({'id': element.id, 'name': element.name})
                            }
                        })
                    })
                })
            },

            searchQuery: function() {
                this.currentPage = 1
                this.chamadosUser = this.getFilteredObject().filter(row => {
                    const clientName = row.customer_name.toLowerCase()
                    const protocolNumber = row.protocol.toLowerCase()
                    const department = row.department_name.toLowerCase()
                    const status = row.status_name.toLowerCase()
                    const createdAt = this.formatDate(row.created_at)
                    const keyword = this.searchQuery.toLowerCase()
                    const tech = this.getOccurrenceTech(row).toLowerCase()
                    return (clientName.includes(keyword) ||
                            protocolNumber.includes(keyword) ||
                            department.includes(keyword) ||
                            status.includes(keyword) ||
                            createdAt.includes(keyword) ||
                            tech.includes(keyword))
                })
            },

            statusSelect: function(){
                this.searchQuery = '';
                this.currentPage = 1;
                this.chamadosUser = this.obj;
                this.chamadosUser = this.chamadosUser.filter(row => {
                    const status = row.status_name.toLowerCase();
                    if (this.statusSelect == '*') return (status.includes('aberto') || status.includes('andamento') || status.includes('finalizado') || status.includes('pendente fornecedor') || status.includes('validação cliente'));
                    else if (this.statusSelect == 'aberto') return status.includes('aberto');
                    else if (this.statusSelect == 'andamento') return status.includes('andamento');
										else if (this.statusSelect == 'pendente fornecedor') return status.includes('pendente fornecedor');
										else if (this.statusSelect == 'validação cliente') return status.includes('validação cliente');
                    else return status.includes('finalizado');

                });

            },
        },

    }

</script>

<style scoped>

    #loadingTable {
        color: rgb(28,134,154);
        font-size: 16px;
        text-align: center
    }

    #loading {
        display: flex;
        justify-content: center;
        padding: 20px;
        position: absolute;
        width: 95%;
        border: solid 1px lightgray
    }

    #loading p {
        color: rgb(28,134,154)
    }

    #message {
        display: flex;
        justify-content: center;
        padding: 20px;
        position: absolute;
        width: 95%;
        border: solid 1px lightgray
    }

    #message p {
        color: rgb(28,134,154)
    }

    #filterDiv {
        margin: 5px;
        display: flex;
        justify-content: flex-end;
        line-height: 15px
    }

    #filterDiv label {
        align-self: center;
        margin: 5px;
    }

    #filterDiv input {
        width: auto;
        align-self: center;
        margin: 5px;
    }

    #filterDiv button {
        height: auto;
        margin: 5px;
        margin-right: 20px;
        background-color: rgb(28,134,154)
    }

    #statusSelect {
        width: auto;
        height: auto;
        margin: 5px;
    }
    #bottomDiv {
        display: flex;
        justify-content: flex-end;
        margin: 10px;
    }

    #bottomDiv p{
        margin: 0;
        padding: 2px 10px;
        background-color: lightgray;
        border-radius: 10px;
        margin-right: 10px;
    }

    #bottomDiv button {
        border: 1px solid rgb(28,134,154);
        border-radius: 10px;
        border-bottom: solid 2px #f38630;
        padding: 0px 10px;
        width: 75px;
        height: 30px;
    }

    #bottomDiv button:hover {
        background-color:rgb(106, 152, 161);
        color: white;
        font-weight: bold;
    }
    /* th {
        vertical-align: middle;
        border-top: 3px solid #f38630;
        font-weight: 700;
        cursor: pointer;
        width: 150px;
    } */

    .buttonCSV {
        border: solid 2px #088a13;
        border-radius: 10px;
        font-size: 12px;
        width: auto;
        font-weight: 600;
        color: white;
        background-color: #088a13;
        padding: 5px;
        margin: 5px;
        transition: 0.5s;
    }

    .buttonCSV:hover {
        background-color: white;
        color: #088a13
    }
    .buttonPDF {
        border: solid 2px #ad1e19;
        border-radius: 10px;
        font-size: 12px;
        width: auto;
        font-weight: 600;
        color: white;
        background-color: #ad1e19;
        padding: 5px;
        margin: 5px;
        transition: 0.5s;
    }

    .buttonPDF:hover {
        background-color: white;
        color: #ad1e19
    }


    td {
        vertical-align: middle;
        padding: 5px;
        font-weight: 500;
        width: 150px;
    }

    td:nth-child(1),
    th:nth-child(1){
        width: 160px;
    }
    td:nth-child(2),
    th:nth-child(2){
        width: 160px;
    }
    td:nth-child(3),
    th:nth-child(3){
        width: 110px;
    }
    td:nth-child(4),
    th:nth-child(4){
        width: 300px;
    }
    td:nth-child(5),
    th:nth-child(5){
        width: 200px;
    }
    td:nth-child(8),
    th:nth-child(8) {
        width: 30px;
    }

    .fa-arrow-up {
        color: palegreen;
    }

    .fa-arrow-down {
        color: palevioletred;
    }

    .noSelect {
        user-select: none;
    }

    tbody tr {
        border: 1px solid lightgray;
    }

    table{
        border: 1px solid lightgray;
    }

    tr:hover{
        background-color: rgb(206, 206, 206);
    }
    td:hover{
        background-color: rgba(199, 197, 197, 0.822);
    }

    .input-group-prepend {
        margin: .3em;
        padding: .3em;
    }

    .input-group-text {
        width: 18em;
        justify-content: center;
        font-weight: 600;
    }

    .row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        align-items: center;
    }

    .column {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
        height: 100%;
        background-color: white;
    }

		.modal {
			display: block; /* Hidden by default */
			position: fixed; /* Stay in place */
			z-index: 3; /* Sit on top */
			left: 1%;
			right: 1%;
			top: 8%;
			width: 98%; /* Full width */
			height: 85vh; /* Full height */
			background-color: #F8F9F9; /* Fallback color */
			border: solid 2px black;
			border-radius: 15px;

		}
		.modal-content {
      background-color: #F8F9F9;
      /* margin: 1%; 10% from the top and centered */
      padding: 0;
      width: 100%; /* Could be more or less, depending on screen size */
			height: 100%;
    }

    .sticky-header th {
        vertical-align: middle;
        font-weight: 700;
        cursor: pointer;
        width: 150px;
        position: sticky;
        top: 0
    }

    #details{
        width: 100%;
        height: 100%;
        overflow-y: hidden;
    }

    /* .formHeader {
        background-color: rgb(28,134,154);
        border-top: 3px solid #f38630;
        color: white;
        padding: 0.2em;
    } */

			.formHeader2 {
					background-color: rgb(28, 134, 154);
					border-top: 3px solid #06628a;
					color: white;
					padding: 0.2em;
			}

		.formHeader {
			background-color: #06628a;
			border-top: 3px solid;
			display: flex;
			justify-content: space-between;
			align-items: center;
			color: white;
			padding: 0.2em;
			border-radius: 15px;
		}

		.header-content, #closeButtonDiv {
				flex-shrink: 0; /* Evita que os elementos encolham abaixo do seu tamanho de conteúdo */

		}

		#closeButtonDiv {
				margin-left: auto; /* Empurra o botão de fechar para a direita */
		}

    #formBody {
        text-align: -webkit-center;
        width: auto;
        height: 100%;
        overflow-y: auto;
        margin: 10px;
    }

    #closeButtonDiv{
       position: absolute;
       width: 100%;
       text-align: end;
    }

    #closeButton {
        margin: 6px;
        background-color: rgba(0,0,0,0);
        color: white;
        border: none;
        position: initial;
    }

    #closeButton:hover {
        color: #f38630;
    }

    #tituloDetalhes {
         font-weight: 700;
         font-size: 18px;
         color: rgb(28,134,154);
         padding: 2px;
    }
	.modal-fullscreen-sm-down {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		/* background-color: rgba(0, 0, 0, 0.5); */
		background-color: #F8F9F9;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1050;
		overflow-y: auto; /* Adiciona uma barra de rolagem vertical somente se necessário */
		max-height: 100vh; /* Define a altura máxima para 100% da altura da viewport */
		margin-bottom: 1%;

	}

@media (max-width: 768px) {
    .modal-fullscreen-sm-down {
        overflow-y: auto; /* Adiciona uma barra de rolagem vertical somente se necessário */
        max-height: 100vh; /* Define a altura máxima para 100% da altura da viewport */
				margin-top: 1%;
				margin-bottom: 1%;
    }
}


</style>
